import React from "react";
import Link from "../../Link";

import Social from "./component/Social";
import ReadLaterIcon from "../../ReadLater";

const Bloger = props => {
  var s = props.settings,
    bi = s["background-image"] ? s["background-image"] : "",
    avatar = window.MEDIA_DOMAIN + "/" + bi.replace(".", ",102,101,1,0.");

  return (
    <div className="row">
      <Link to={s.blog_url} className="hp__box__bloger__link">
        <img
          alt={s.blog_author}
          align="center"
          src={avatar}
          className="hp__box__bloger__photo"
        />
        <span className="hp__box__bloger__author container text-uppercase">
          {s.blog_author}
        </span>
        <ReadLaterIcon
          link={s.link}
          image={window.MEDIA_DOMAIN + "/" + bi.replace(".", ",300,300,1,0.")}
          title={s.title_normal}
          isBloger
        />
      </Link>

      <div className="hp__box__bloger__content">
        <Link to={s.link}>
          <h2 className="hp__box__title no-margin-padding">{s.title_normal}</h2>
          <hr className="hp__box__bloger__separator" />
          <p className="hp__box__blog__text">{s.blog_text}</p>
        </Link>
        <Social link={s.link} />
      </div>
    </div>
  );
};

export default Bloger;
